module.exports = __webpack_public_path__ + "img/bantainapp-logo.91c4b83b.png";